import util from "@/util";
import timeslotWeekdayPrefModelDefinition from './timeslotWeekdayPref'
import { COLOR_LIST } from "@/misc/colors";
import moment from '@/moment-gp'

export default {
  create({ type }, data) {

    let testWeekdayPreferenceId = null;

    const CREATE_EXAMPLE_WEEKDAY_PREF = false;

    if ( CREATE_EXAMPLE_WEEKDAY_PREF ) {
      testWeekdayPreferenceId = util.get_new_uuid();
    }

    let timeslot_collection = {
      createdAt:            moment.currentTimeServer('REALTIMEDB'),
      type:                 type, // [ENUM] -> ['TSC', 'BLOCKER', 'GOOGLE']
      name:                 '', // [String]
      sortidx:              1, // [Numeric]
      deleted:              false, // [Boolean]
      color:                '#000000', // [RGB-String]
      // weekday_preferences:  {}, // 15.04.2019 --> raus
      // exception_list:       [], // 15.04.2019 --> raus
      // createdBy: current_user,
      // optimizer_include: true,
    };

    switch ( type ) {
      case 'TSC':
        let randomColor = COLOR_LIST[ Math.floor( Math.random() * COLOR_LIST.length ) ];
        timeslot_collection.name  = data.name || 'Working hours';
        timeslot_collection.color = data.color || randomColor; // '#F58652';
        if ( CREATE_EXAMPLE_WEEKDAY_PREF ) {
          timeslot_collection.weekday_preferences[ testWeekdayPreferenceId ] =
            timeslotWeekdayPrefModelDefinition.schema.create()
          /* {
            [testWeekdayPreferenceId]: {
              // [Integer]
              sortidx: 1,

              // [String]
              selectedWeekdays: '--x--x-',

              // [Time ISO 8601]
              from: '15:00',

              // [Time ISO 8601] or <null>
              to: '18:00',

              // [Date ISO 8601] or <null>
              valid_after: null,

              // [Date ISO 8601] or <null>
              valid_before: null,
            }
          }*/
        }
        timeslot_collection.prioritizedCommitmentType = 'COMMITMENT';
      break;

      case 'BLOCKER':
        timeslot_collection.name = 'Blocker';
        timeslot_collection.color = '#000000';
        delete timeslot_collection.weekday_preferences;
      break;

      case 'GOOGLE':
        timeslot_collection.name = 'My Google Calendar';
        timeslot_collection.color = '#0000FF';
        delete timeslot_collection.weekday_preferences;
      break;

      /* Special case when commitment acts as TSC */
      case 'COMMITMENT':
        timeslot_collection.name = 'My commitment';
        timeslot_collection.color = '#FF00FF';
      break;
    }
    return timeslot_collection;
  },
  fields: {
    type:      { validate_bolt_type: 'String' },
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    name:      { validate_bolt_type: 'String' },
    sortidx:   { validate_bolt_type: 'Number' },
    deleted:   { validate_bolt_type: 'Boolean' },
    color:     { validate_bolt_type: 'String' },
    // weekday_preferences: { validate_bolt_type: 'TimeslotWeekdayPref[]' },
    // exception_list: { validate_bolt_type: 'TimeslotException[]' },
    prioritizedCommitmentType: {}, // TODO raus
  }
}
